import { render } from "./Work.vue?vue&type=template&id=9da18b8c&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=9da18b8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9da18b8c"

export default script